import React, { useState, useEffect } from 'react';
import { useApi } from '../hooks/useAPI';

function RaceSelector({ onGridReady }) {
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedRace, setSelectedRace] = useState('');

  // API hook for fetching the list of races
  const { 
    data: races, 
    isLoading: racesLoading, 
    error: racesError, 
    getData: getRaces 
  } = useApi();
  
  // A *separate* API hook for fetching the list of drivers
  const { 
    data: drivers, 
    isLoading: driversLoading, 
    error: driversError, 
    getData: getDrivers 
  } = useApi();

  // --- Effects ---

  // Effect 1: Fetch races when a year is selected
  useEffect(() => {
    if (selectedYear) {
      setSelectedRace(''); // Reset race selection
      getRaces(`/api/races?year=${selectedYear}`);
    }
  }, [selectedYear, getRaces]);

  // Effect 2: Fetch drivers when a race is selected
  useEffect(() => {
    if (selectedYear && selectedRace) {
      getDrivers(`/api/drivers?year=${selectedYear}&race_name=${selectedRace}`);
    }
  }, [selectedYear, selectedRace, getDrivers]);

  // --- Handlers ---

  const handleSubmit = () => {
    onGridReady({
      year: selectedYear,
      raceName: selectedRace,
      drivers: drivers,
    });
  };

  // --- Validation ---
  const isReady = selectedYear && selectedRace && !driversLoading && drivers;
  const yearOptions = [2024, 2023, 2022, 2021, 2020, 2019, 2018];

  // --- Render ---

  return (
    // *** THIS IS THE UPDATED LINE ***
    // We changed bg-f1-gray-dark to bg-black/50, added backdrop-blur and a border
    <div className="max-w-xl mx-auto p-8 bg-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10">
      <h2 className="text-3xl font-bold text-white mb-6 text-center">Select Race</h2>
      <div className="space-y-6">
        {/* Year Selector */}
        <div>
          <label htmlFor="year" className="block text-sm font-medium text-gray-300 mb-2">
            1. Select Year
          </label>
          <select
            id="year"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="w-full p-3 bg-f1-gray rounded-md text-black border-2 border-f1-gray-light focus:border-f1-red focus:ring-f1-red"
          >
            <option value="" disabled>Select a year</option>
            {yearOptions.map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>

        {/* Race Selector */}
        <div>
          <label htmlFor="race" className="block text-sm font-medium text-gray-300 mb-2">
            2. Select Race
          </label>
          <select
            id="race"
            value={selectedRace}
            onChange={(e) => setSelectedRace(e.target.value)}
            disabled={!selectedYear || racesLoading || !races}
            className="w-full p-3 bg-f1-gray rounded-md text-black border-2 border-f1-gray-light focus:border-f1-red focus:ring-f1-red
                       disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <option value="" disabled>
              {racesLoading ? 'Loading races...' : (selectedYear ? 'Select a race' : 'Select a year first')}
            </option>
            {races && races.map(race => (
              <option key={race} value={race}>{race}</option>
            ))}
          </select>
        </div>

        {/* Error Display */}
        {(racesError || driversError) && (
          <p className="text-f1-red text-center">
            Error: {racesError?.message || driversError?.message}
          </p>
        )}

        {/* Submit Button */}
        <button
          onClick={handleSubmit}
          disabled={!isReady || driversLoading}
          className="w-full py-4 px-6 bg-f1-red text-white text-lg font-bold rounded-lg shadow-lg transition-all duration-300
                     disabled:bg-f1-gray disabled:opacity-50 disabled:cursor-not-allowed
                     hover:bg-red-700"
        >
          {driversLoading ? 'Loading Drivers...' : 'Set Starting Grid'}
        </button>
      </div>
    </div>
  );
}

export default RaceSelector;